import {useAppConfig} from '@/hooks/use-app-config'
import type {AttributeDefinition} from '@/types/attribute-definition'
import {ValueSourceType} from '@/types/attribute-definition'

interface ResolvedValue {
    code: string
    label: string
}

export function useValueSourceResolver(definition: AttributeDefinition): ResolvedValue[] {
    const appConfig = useAppConfig()
    const vs = definition.validationRules?.valueSource

    if (!vs) return []

    if (vs.type === ValueSourceType.LIST) {
        return (vs.values ?? []).map(entry => ({code: entry.code, label: entry.label}))
    }

    if (vs.type === ValueSourceType.ENUM && vs.typeName) {
        const values = appConfig.typeValuesByName[vs.typeName]
        if (values) {
            return values.map(v => ({code: v.code, label: v.label}))
        }
    }

    // SQL, SQL_LABELED, CUSTOM_LIST: use server-resolved values (handles ${lang} substitution)
    if (definition.resolvedAllowedValues && definition.resolvedAllowedValues.length > 0) {
        return definition.resolvedAllowedValues.map(v => ({code: v.code, label: v.label}))
    }

    return []
}
